import { AuthProvider } from "@bw/shared/components";
import { BwMaterialProvider } from "@bw/material";
import type { ReactNode } from "react";
import { createPlayerTheme } from "./theme";
import { PlayerErrorBoundary } from "./PlayerErrorBoundary";

const playerTheme = createPlayerTheme();

// The single QueryClientProvider now lives INSIDE <Router/> (app/router.tsx) so
// the router is a self-contained unit testable with only an AuthContext above
// it — mirroring the business app. Providers therefore owns only the auth
// session boundary; the client is no longer wired here (avoids a duplicate).
export function Providers({ children }: { children: ReactNode }) {
  return (
    <BwMaterialProvider
      theme={playerTheme}
      defaultMode="dark"
      storageManager={null}
    >
      <PlayerErrorBoundary>
        <AuthProvider>{children}</AuthProvider>
      </PlayerErrorBoundary>
    </BwMaterialProvider>
  );
}
